module.exports = __webpack_public_path__ + "static/media/resume-editors.ed10cf9c.svg";